import { Badge, Typography } from 'antd';
import './CardDataDisplay.scss';

const { Title, Text } = Typography;

interface CardTitleProps {
  title: string;
}
const CardTitle = ({ title }: CardTitleProps) => {
  return (
    <Title className={'CardTitle__title'} level={3}>
      {title}
    </Title>
  );
};

interface CardInfoProps {
  label: string;
  data: string;
  id: string;
  color?: string;
  onSave?: (val: number) => Promise<void>;
}

const CardInfo = ({ label, data, id, color, onSave }: CardInfoProps) => {
  return (
    <div className={'CardInfo'}>
      <Text type={'secondary'} className={'CardInfo__label'}>
        {label}
      </Text>
      {id === 'state' && (
        <div className={'CardInfo__status'}>
          <Badge dot style={{ backgroundColor: color }} />
          <Text>{data}</Text>
        </div>
      )}
      {id === 'limit' && (
        <div>
          <Text>{data}%</Text>
        </div>
      )}
      {id !== 'state' && id !== 'limit' && <Text>{data}</Text>}
    </div>
  );
};

export { CardTitle, CardInfo };
